/**
 * Token storage for native auth.
 *
 * Kept in a tiny module (not the Zustand store) so lib/api.ts can attach
 * the Authorization header without importing the store — which would be an
 * import cycle (the store calls apiFetch for login/refresh).
 */

const ACCESS_KEY = 'rdp.access_token';
const REFRESH_KEY = 'rdp.refresh_token';

function storage(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function getAccessToken(): string | null {
  return storage()?.getItem(ACCESS_KEY) ?? null;
}

export function getRefreshToken(): string | null {
  return storage()?.getItem(REFRESH_KEY) ?? null;
}

export function setTokens(accessToken: string, refreshToken: string): void {
  const s = storage();
  s?.setItem(ACCESS_KEY, accessToken);
  s?.setItem(REFRESH_KEY, refreshToken);
}

export function setAccessToken(accessToken: string): void {
  storage()?.setItem(ACCESS_KEY, accessToken);
}

export function clearTokens(): void {
  const s = storage();
  s?.removeItem(ACCESS_KEY);
  s?.removeItem(REFRESH_KEY);
}
